/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-text[_ngcontent-%COMP%]{font-size:medium;font-weight:700;text-align:center;border-left:4px solid #d32f2f;border-radius:5px;margin:20px 0;position:relative;background:0 0;display:inline-flex;align-items:center;color:#d32f2f}.alert-icon[_ngcontent-%COMP%]{margin-right:10px;font-size:24px;color:#d32f2f}"];
export { styles as styles };
